import { Component, Fragment } from "react"
import {
    DKLabel,
    DKInput,
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    showAlert,
    DKIcon,
    DKIcons,
    DKLine
} from "deskera-ui-library";
import RouteManager from "../../managers/RouteManager";
import Utility from "../../utility/Utility";
import { RATE_MULTI_OT_COLUMN } from "./OvertimeConstants";
import { TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { COMPANY_DATE_FORMATS } from "../../constants/Constant";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import getSymbolFromCurrency from "currency-symbol-map";
import OvertimeApiService from "../../services/OvertimeService";
import i18next from "i18next";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
export default class OvertimeRateConfiguration extends Component {
    dateFormat = COMPANY_DATE_FORMATS.filter(c=>c.label==TenantService.get(TENANT.DATE_FORMAT))
    currencySymbol = getSymbolFromCurrency(TenantService.get(TENANT.CURRENCY_CODE));
    selection = []
    id;
    constructor(props) {
        super(props)
        this.state = {
            configurationData: {
                columnData:  RATE_MULTI_OT_COLUMN,
                rowData: [],
                filter: [],
                originalData: []
            },
            currentPage:1,
            totalPageCount: 0
        }
        this.dateFormat = this.dateFormat[0]?.value;
        this.getOvertimeMultiplier();
    }
    componentDidMount() {
        this.setState({
            ...this.state,
            configurationData: {
                columnData:RATE_MULTI_OT_COLUMN,
                rowData: [],
            filter: [],
            originalData: []
            }
        })
        RouteManager.setPresenter(this);
    }
    getOvertimeMultiplier() {
        showLoader()
        OvertimeApiService.getOvertimeMultiplier().then(res=>{
            if(res && res.overtimePayrollMultiplier && res.overtimePayrollMultiplier.overtimeMultiplierValues) {
                this.id = res.overtimePayrollMultiplier.id;
                this.setState({
                    ...this.state,
                    configurationData: {
                        columnData:this.state.configurationData.columnData,
                        rowData: res.overtimePayrollMultiplier.overtimeMultiplierValues,
                    filter: [],
                    originalData: res.overtimePayrollMultiplier.overtimeMultiplierValues
                    }
                })
            }
        },
        error=>{
            console.log(error);
        }).finally(()=>{
            removeLoader()
        })
    }
    
    onRowDelete(data) {
        const rowData = data && data.rowData ? data.rowData : '';
        let newRows = this.state.configurationData?.rowData ? this.state.configurationData.rowData : [];
        if (rowData && typeof data == 'object') {
            newRows.splice(data.rowIndex, 1);            
        } else {
            let valuesToBeRemoved = data.map((row) => row.value);
            newRows = newRows.filter((row) => !valuesToBeRemoved.includes(row.value));
        }
        let newConfigurationData = {
            ...this.state.configurationData,
            rowData: newRows
        }
        this.save(newConfigurationData.rowData, true);
    }
    onRowClick(data) {
        console.log(data)
    }
    onRowUpdate(data) {
        let decimalFormat = TenantService.get(TENANT.DECIMAL_FORMAT)
        if(data.rowData.isCreateNew && !PermissionUtils.hasAccess(MODULE.OT_MULTIPLIER, ACTION.CREATE)) {
            showAlert("Alert", "You don't have permission to create new Overtime Multiplier")
            this.getOvertimeMultiplier();
            return
        } else if(!data.rowData.isCreateNew && !PermissionUtils.hasAccess(MODULE.OT_MULTIPLIER,ACTION.EDIT)) {
            showAlert("Alert", "You don't have permission to edit existing Overtime Multiplier")
            this.getOvertimeMultiplier();
            return
        }
        if(data.rowData.value) {
            const ind = data.rowData.value?.trim()?.indexOf('.');
            if(ind != -1) {
                const substr = data.rowData.value.substring(ind,data.rowData.value.length)
                if(substr.length > decimalFormat ) {
                        data.rowData.value = parseFloat(data.rowData.value?.trim())?.toFixed(decimalFormat)
                    
                } else if(substr.length == 1) {
                    data.rowData.value = data.rowData.value?.toString()?.replace(".","");
                } else {
                    data.rowData.value = data.rowData?.value?.trim()
                }
            } else {
                data.rowData.value = data.rowData?.value?.trim()
            }
        } else {
            data.rowData.value = data.rowData?.value?.trim()
        }
        
        if(Utility.isEmpty(data.rowData.value.trim())) {
            data.rowData['invalidFields'] = [data.columnData.columnCode]
        } else {
            data.rowData['invalidFields'] = []
        }
        let isDuplicate = false;
        this.state.configurationData.rowData.forEach((element,index)=>{
            let ind = this.state.configurationData.rowData.findIndex((subElement,subInd)=>element.value == subElement.value && index!=subInd);
            if(ind != -1) {
                isDuplicate = true;  
            }
        })
        if(isDuplicate) {
            data.rowData['invalidFields'] = [data.columnData.columnCode]
            return;
        }
        
        this.save(this.state.configurationData.rowData);
    }
    save(data,isDelete) {
        let isInvalidField = false;
        let rowData = data.map(d=>{
            if(d.invalidFields && d.invalidFields.length != 0) {
                isInvalidField = true;
            }
            return {
                value:d.value,
                description:d.description
            }
        })
        if(isInvalidField) {
            showToast("There are some invalid fields in grid table.",TOAST_TYPE.FAILURE);
            return
        }
        let param = {
            "overtimeMultiplierValues": rowData
        }
        if(this.id) {
            param['id'] = this.id;
        }
        showLoader()
        OvertimeApiService.saveOvertimeMultiplier(param).then(res=>{
            if(isDelete) {
                showToast(i18next.t("OT_DELETE_SUCCESS"),TOAST_TYPE.SUCCESS);
            } else {
                showToast(i18next.t("OT_SAVE_SUCCESS"),TOAST_TYPE.SUCCESS);
            }
            this.getOvertimeMultiplier();
        },error=>{
            if(error && error.message && error.code == 2) {
                showToast(error.message,TOAST_TYPE.FAILURE);
            }
            this.getOvertimeMultiplier();
        }).finally(()=>{
            removeLoader()
        })
    }
    onAddNewConfig() {
        let newRowData = {
            description: "",
            value: "",
            isCreateNew:true,
            invalidFields:['value']
        }
        let newRows = this.state.configurationData?.rowData ? this.state.configurationData.rowData:[] ;
        newRows.push(newRowData)
        let newConfigurationData = {
            ...this.state.configurationData,
            rowData: newRows
        }
        this.setState({
            ...this.state,
            configurationData: newConfigurationData
        })
    }
     getGiroGrid() {
        return (
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_OVERTIME_RATE_CONFIG}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_OVERTIME_RATE_CONFIG]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={PermissionUtils.hasAccess(MODULE.OT_MULTIPLIER, [ACTION.CREATE,ACTION.EDIT])}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={false}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.state.configurationData}
                        filter={this.state.configurationData}
                        currentPage={this.state.currentPage}
                        totalPageCount={this.state.totalPageCount}
                        addButtonConfig={[
                            {
                                title: `+ Add ${TABLE_DISPLAY_NAME[TABLES.PEOPLE_OVERTIME_RATE_CONFIG]}`,
                                className: "bg-app text-white ml-s",
                                onClick: () => {
                                    this.onAddNewConfig()
                                },
                              }
                        ]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onSelection={(selection) => {
                            this.selection = (selection);
                        }}
                        // onRowEdit={onRowEdit}
                        allowBulkOperation={true}
                        // dateFormat={dateFormat}

                        onCancelContext={() => {
                            // this.onContextCancel();
                        }}
                        // contextMenu={false}
                        onRowClick={(data) => {
                            this.onRowClick(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            // this.grid.gridActions.currentPage = requestedPageNumber
                            // this.getAttendanceData()
                        }}
                        // isMenuVisible={false}
                        // onView={onView}
                        module={MODULE.OT_MULTIPLIER}
                    />
                </div>
            </div>
        )
    }
    render() {
        return (
            <Fragment>
                {this.getGiroGrid()}
            </Fragment>
        )
    }
}